// sharePreference.js - Remember the user's preferred share mode (link vs image).

const SHARE_MODE_KEY = 'pista_share_mode_preference';

export const SHARE_MODE_LINK = 'link';
export const SHARE_MODE_IMAGE = 'image';

/**
 * @returns {'link' | 'image' | null}
 */
export function getShareModePreference() {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const value = window.localStorage.getItem(SHARE_MODE_KEY);
    if (value === SHARE_MODE_LINK || value === SHARE_MODE_IMAGE) return value;
    return null;
  } catch (e) {
    return null;
  }
}

/**
 * @param {'link' | 'image' | null} mode
 */
export function setShareModePreference(mode) {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    if (mode === SHARE_MODE_LINK || mode === SHARE_MODE_IMAGE) {
      window.localStorage.setItem(SHARE_MODE_KEY, mode);
    } else {
      window.localStorage.removeItem(SHARE_MODE_KEY);
    }
  } catch (e) {
    // Ignore storage errors (e.g. private browsing)
  }
}
